// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_1-0";
export var footer = "_1-2";
export var infoSection = "_1-3";
export var infoSectionContainer = "_1-4";
export var infoSectionTitleRow = "_1-5";
export var itemDetails = "_1-6";
export var line = "_1-7";
export var lineItemImage = "_1-1";
export var lineItems = "_1-8";
export var modalContent = "_1-9";
export var multiLineInfo = "_1-a";
export var orderName = "_1-b";
export var strong = "_1-c";